module.exports = __webpack_public_path__ + "static/media/logo.a2d07712.webp";